export const virtualDetailModalStyle = {
  modal: {
    position: 'absolute',
    top: {
      xs: 0,
      md: '50%',
    },
    left: {
      xs: 0,
      md: '50%',
    },
    transform: {
      xs: 'initial',
      md: 'translate(-50%, -50%)',
    },
    background: '#FFF',
    outline: 'none',
    width: '100%',
    maxWidth: {
      xs: '100%',
      md: '90%',
      lg: '80%',
      xl: '60%',
    },
    flexDirection: {
      xs: 'column',
      md: 'row',
    },
    display: 'flex',
    borderRadius: {
      xs: 0,
      md: '8px',
    },
    height: {
      xs: '100%',
      md: 'unset',
    },
    minHeight: 650,
    overflowX: 'hidden',
  },
  leftSectionStyle: {
    borderRight: {
      xs: 'none',
      md: '1px solid #DDD',
    },
    display: 'flex',
    flexDirection: 'column',
    minWidth: {
      xs: 'initial',
      md: 350,
    },
    maxWidth: {
      md: 350,
    },
  },
  rightSection: {
    flex: 1,
    padding: '1rem',
    overflowX: 'hidden',
  },
  rightSectionHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: 1,
  },
  paidoutStyle: {
    position: 'absolute',
    top: 0,
    left: 0,
    padding: '.3rem .8rem',
    margin: 1,
    background: 'transparent',
    borderRadius: 8,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    gap: 0.5,
  },
  connectionChip: {
    position: 'absolute',
    top: {
      xs: '2.6rem',
      md: 0,
    },
    right: {
      xs: 'auto',
      md: 0,
    },
    left: {
      xs: 0,
      md: 'auto',
    },
    padding: '.3rem .8rem',
    margin: 1,
    background: '#FFF',
    borderRadius: 8,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 0.5,
  },
  profileImgWrapper: {
    position: 'relative',
  },
  profileImg: {
    width: '100%',
    height: 290,
    transition: 'all .2s ease-in',
    objectFit: 'cover',
  },
  tvlLeft: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    gap: '0.5rem',
  },
  tvlValue: {
    fontSize: {
      xs: '1.3rem',
      md: '1.7rem',
    },
    fontWeight: 700,
  },
  tvlChip: {
    borderRadius: '50px',
    backgroundColor: 'rgba(67, 189, 206, 0.10)',
    padding: '.3rem 2rem',
    fontWeight: 700,
    fontSize: '0.9rem',
  },
  virtualLocked: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: {
      xs: 'space-between',
      lg: 'center',
    },
    gap: 1,
    margin: '1rem 0',
    flexDirection: {
      xs: 'row',
      md: 'column',
    },
  },
  aprBadgeStyle: {
    borderRadius: 10,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    background: '#F5F5F5',
    width: '100%',
    color: '#404040',
    marginBottom: '1rem',
    paddingY: '0.5rem',
    gap: 0.5,
  },
  aprTextStyle: {
    fontSize: '1.3rem',
    fontWeight: 700,
  },
  virtualValidatorSummary: {
    textAlign: 'center',
    color: '#43BDCE',
    overflow: 'hidden',
    transition: 'all .2s ease-in-out',
    width: '100%',
  },
  virtualNameRow: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
    flexDirection: {
      xs: 'row',
      md: 'row',
    },
    gap: 2,
  },
  virtualType: {
    backgroundColor: '#43BDCE',
    color: '#FFF',
    padding: '.3rem .7rem',
    textTransform: 'uppercase',
    borderRadius: 10,
    fontSize: '.9rem',
    fontWeight: 700,
  },
  virtualName: {
    fontWeight: 700,
    fontSize: {
      xs: '1.2rem',
      md: '1.5rem',
    },
  },
  virtualInfoWrapperStyle: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    flex: 1,
    justifyContent: 'space-between',
    padding: {
      xs: '1rem 1rem 0 1rem',
      md: '1rem',
    },
  },
  virtualInfoStyle: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100%',
  },
  stakeDrawerStyle: {
    position: {
      xs: 'fixed',
      md: 'absolute',
    },
    top: 0,
    right: 0,
    height: '100%',
    bgcolor: '#fff',
    zIndex: 2,
    boxShadow: '0 0 5px 5px rgba(0, 0, 0, .1)',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    maxHeight: '100dvh',
    width: {
      xs: '100%',
      md: '50%',
    },
    maxWidth: {
      xs: '100%',
      lg: '500px',
    },
  },
  virtualDescStyle: {
    color: '#404040',
    border: '1px solid #DDD',
    padding: '0.5rem',
    maxWidth: {
      xs: 'initial',
      md: '100%',
    },
    marginBottom: '1rem',
    maxHeight: '100px',
    overflowY: 'auto',
  },
  inputStakeAmount: {
    marginBottom: '1rem',
  },
  btnStake: {
    borderRadius: '8px',
  },
  validatorInfo: {
    display: 'flex',
    flexDirection: 'column',
    borderRadius: '8px',
    gap: '.5rem',
    padding: '1rem',
    backgroundColor: '#F5F5F5',
    margin: '.5rem 0',
  },
  btnShowVirtual: {
    alignSelf: 'start',
    padding: '.1rem .5rem',
    marginTop: '.5rem',
    minHeight: 'unset',
    lineHeight: 'unset',
    fontSize: '.8rem',
    borderRadius: '50px',
    display: {
      xs: 'flex',
      md: 'none',
    },

    '& .MuiButton-endIcon svg': {
      transition: 'all .2s ease-in',
    },
  },
  btnClose: {
    backgroundColor: '#fff',
    position: {
      xs: 'absolute',
      md: 'relative',
    },
    top: {
      xs: 0,
      md: 'initial',
    },
    right: {
      xs: 0,
      md: 'initial',
    },
    margin: {
      xs: '0.5rem',
      md: 'initial',
    },
    padding: 0,
    minWidth: 'unset',
    width: '45px',
    height: '45px',
    borderRadius: '50%',
  },
  btnMax: {
    minHeight: 'unset',
    lineHeight: 'unset',
    padding: '0 16px',
  },
  maturityBarWrapper: {
    position: 'absolute',
    bottom: '8px',
    left: '50%',
    transform: 'translateX(-50%)',
    flexDirection: 'row',
    width: '100%',
  },
  maturityBar: {
    backgroundColor: '#fff',
    margin: '0.5rem',
    borderRadius: '50px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '0.5rem',
    padding: '0 0.5rem',
  },
};
